'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLeaf = function IoLeaf(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.7 29.6c1.4 0.2 0.8 3.2-0.4 3.1 0 0-1.6 0-4.9-1 0 0-1.3 1.5-3.1 2.4-2 0.9-9.2 2.5-15.4-3-8.4-7.6-9.3-27.7-7.8-26 6.7 7 15.4 3.7 21.1 8.3 4.3 3.4 6.9 9.9 6 15 0 0 0.4 0.6 4.5 1.2z m-7.5 0.3c0.4-0.4 0.8-1.2 0.8-1.9-12.6-4-19.7-12.5-19.7-12.5s8.1 11.2 18.9 14.4z' })
        )
    );
};

exports.default = IoLeaf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/leaf.js
// module id = 2360
// module chunks = 0